// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3S8YZ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1jTew","obliqueLine":"membershipbadge_obliqueLine__oM7fd"};